import React from 'react'
import MakeHomepage from '../make-homepage'

const MakeHomepagePt = () => {
    return <MakeHomepage languageCode="pt" />
}

export default MakeHomepagePt
